// extracted by mini-css-extract-plugin
export default {"statsRow":"StatsRow_statsRow__JgFbq"};